import styled from "styled-components";
import { COLORS, responsive } from "../../../../../styles/constants.style";

export const BulkTransferDetailsWrapper = styled.div`
  .form-header {
    padding-left: 16px;
    display: flex;
    justify-content: space-between;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
      .title-container {
        display: flex;
        align-items: center;
      }
    }
  }

  .activity-details-accordion {
    margin-top: 32px;
    .MuiCollapse-wrapper {
      margin-top: 8px;
    }
    .MuiAccordionSummary-expandIconWrapper {
      margin-left: 16px;
    }

    .selected-count {
      color: ${COLORS.cirrus_white};
      background-color: ${COLORS.cirrus_black7};
      padding: 2px 9px 4px 9px;
      border-radius: 7px;
      margin-left: 8px;
    }

    .error-info-icon {
      cursor: pointer;
    }
  }
  .activity-details-accordion:last-child {
    margin-bottom: 32px;
  }

  .name-field {
    margin: 24px 16px;
    width: 320px;
    ${responsive.MOBILE`
        margin: 0;
        padding: 16px 16px 16px 8px;
        width: 100%;
      `}
  }
`;
